module.exports = __webpack_public_path__ + "static/img/logo_radioImpo.c33d924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/logo_radioImpo.png
// module id = qZGY
// module chunks = 232